<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // กันการกด back ของเบราว์เซอร์: ให้ค้างอยู่หน้าเดิมจนกว่าจะ logout
    window.history.pushState(null, '', window.location.href)
    window.addEventListener('popstate', this.blockBrowserBack)
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.blockBrowserBack)
  },
  methods: {
    blockBrowserBack() {
      // ยังล็อกอินอยู่ -> ดันตัวเองกลับเข้า history stack ทุกครั้งที่กด back
      // หลัง logout localStorage ถูกล้าง back จะทำงานปกติ
      if (localStorage.getItem('access_token')) {
        window.history.pushState(null, '', window.location.href)
      }
    }
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  @import url('https://fonts.googleapis.com/css?family=Mitr');
</style>
